/** Type check to see if the input is typed as CardInput. */
export const isCardInput = (input) => !!input &&
    'name' in input &&
    'type' in input &&
    'uniqueId' in input &&
    typeof input.type === 'object' &&
    typeof input.type.value === 'string';
/** Type check to see if the input is typed as Tag. */
export const isTag = (input) => !!input && 'value' in input && typeof input.value === 'string';
//# sourceMappingURL=folderTypeGuard.js.map